// src/components/molecules/ChallengeCreator/CustomCard.js

import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { useTheme } from "styled-components";

const CustomCard = ({ title, children }) => {
  const theme = useTheme();

  return (
    <Card
      sx={{
        width: "100%",
        border: "none", // Removes the card's border
        borderRadius: 0, // Removes any border-radius
        borderBottomLeftRadius: "25px",
        borderBottomRightRadius: "25px",
        boxShadow: "none", // Removes the shadow/elevation
        mb: 4,
        backgroundColor: theme.colors.mediumPurple,
      }}
    >
      <CardContent
        sx={{
          backgroundColor: theme.colors.darkPurple,
          border: "none", // Remove any potential borders here as well
          padding: "16px", // Padding for the content
        }}
      >
        {/* First row for title */}
        <Typography
          variant="h6"
          component="h2"
          sx={{
            fontFamily: "basic-sans",
            fontSize: "1em",
            fontWeight: 700,
            color: theme.colors.amber,
          }}
        >
          {title}
        </Typography>
      </CardContent>
      {/* Second row for form fields */}
      <Box
        sx={{
          padding: {
            xs: 1,
            sm: 4,
            md: 4,
            lg: 4,
            xl: 8,
          },
          backgroundColor: theme.colors.mediumPurple,
          border: "none", // Remove borders if any
        }}
      >
        {children}
      </Box>
    </Card>
  );
};

export default CustomCard;